import { ReactElement, ReactNode } from 'react';
import Breadcrumbs from '@storeblocks/breadcrumbs';
import styled, { css } from 'styled-components';

interface AppHeaderProps {
  crumbs?: ReactElement[];
  title: string;
  description?: ReactNode;
  caseNumber?: ReactNode;
  children?: ReactNode;
  withoutBorder?: boolean;
}

export const AppHeader = ({
  crumbs,
  title,
  description,
  caseNumber,
  children,
  withoutBorder
}: AppHeaderProps) => (
  <>
    {crumbs && <Breadcrumbs className="data-hj-suppress">{crumbs}</Breadcrumbs>}
    <Wrapper withoutBorder={withoutBorder}>
      <>
        <h1 style={{ paddingBottom: 0, paddingTop: crumbs ? 16 : 32 }}>
          {title}
        </h1>
        {description && <Description>{description}</Description>}
        {caseNumber && (
          <CaseNumber className="data-hj-suppress">{caseNumber}</CaseNumber>
        )}
        {children && { children }}
      </>
    </Wrapper>
  </>
);

const Wrapper = styled.div<{ withoutBorder?: boolean }>`
  ${props => {
    if (props.withoutBorder) {
      return css`
        padding-bottom: 0;
        margin-bottom: 12px;
        border-bottom: none;
      `;
    }

    return css`
      padding-bottom: 24px;
      margin-bottom: 32px;
      border-bottom: 2px solid rgba(25, 25, 25, 0.16);
    `;
  }}
`;

const Description = styled.div`
  font-size: 18px;
  margin-top: 16px;
  line-height: 24px;
  max-width: 522px;
  color: #191919;
`;

const CaseNumber = styled.div`
  font-size: 18px;
  margin-top: 32px;
  line-height: 24px;
  font-weight: 400;
  color: #191919;
`;
